export const getMonthKey = (dateValue = new Date()) => {
  const date = dateValue instanceof Date ? dateValue : new Date(dateValue);

  if (Number.isNaN(date.getTime())) {
    return "";
  }

  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
};

export const getQuarterFromDate = (dateValue = new Date()) => {
  const date = dateValue instanceof Date ? dateValue : new Date(dateValue);

  if (Number.isNaN(date.getTime())) {
    return {
      year: new Date().getFullYear(),
      quarter: 1,
      quarterKey: `${new Date().getFullYear()}-Q1`,
    };
  }

  const year = date.getFullYear();
  const quarter = Math.floor(date.getMonth() / 3) + 1;

  return {
    year,
    quarter,
    quarterKey: `${year}-Q${quarter}`,
  };
};

export const getPreviousQuarterKey = (quarterKey) => {
  const [yearPart, quarterPart] = String(quarterKey || "").split("-Q");

  let year = Number(yearPart);
  let quarter = Number(quarterPart);

  if (!year || !quarter) {
    const current = getQuarterFromDate();
    year = current.year;
    quarter = current.quarter;
  }

  if (quarter === 1) {
    return `${year - 1}-Q4`;
  }

  return `${year}-Q${quarter - 1}`;
};

export const getCurrentQuarterKey = () => {
  return getQuarterFromDate(new Date()).quarterKey;
};

export const getQuarterArchiveAfterDate = (dateValue = new Date()) => {
  const date = dateValue instanceof Date ? dateValue : new Date(dateValue);

  if (Number.isNaN(date.getTime())) {
    return "";
  }

  const year = date.getFullYear();
  const quarter = Math.floor(date.getMonth() / 3) + 1;

  const quarterEndMonthIndex = quarter * 3 - 1;

  const archiveDate = new Date(year, quarterEndMonthIndex + 2, 1);

  return archiveDate.toISOString().split("T")[0];
};

export const shouldArchiveCase = (archiveAfter) => {
  if (!archiveAfter) return false;

  const today = new Date();
  const archiveDate = new Date(archiveAfter);

  today.setHours(0, 0, 0, 0);
  archiveDate.setHours(0, 0, 0, 0);

  return today >= archiveDate;
};
